<div class="reservation_process pb-3" id="reservation_process">
    <h2 class="pt-5 pb-4 mb-0">
        <span class="title_2">{{ 'PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.TITLE' | translate }}</span>
    </h2>

  <div class="subtitle_1 txt-darkGray pb-2">
    <span>
      {{ 'PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEPS' | translate }}
    </span>
  </div>
    <mat-accordion class="custom-panel" multi>
        <mat-expansion-panel class="pb-2">
            <mat-expansion-panel-header class="custom-expansion-panel" step-number="1">
                <mat-panel-title class="subtitle_1 custom-panel-title">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_1.TITLE" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="w-100 d-flex custom-text">
                <p class="text_1">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_1.TEXT" | translate }}</p>
            </div>

        </mat-expansion-panel>
        <mat-expansion-panel class="pb-2">
            <mat-expansion-panel-header class="custom-expansion-panel " step-number="2">
                <mat-panel-title class="subtitle_1 custom-panel-title">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_2.TITLE" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="w-100 d-flex custom-text">
                <p class="text_1">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_2.TEXT" | translate }}</p>
            </div>

        </mat-expansion-panel>
        <mat-expansion-panel class="pb-2">
            <mat-expansion-panel-header class="custom-expansion-panel" step-number="3">
                <mat-panel-title class="subtitle_1 custom-panel-title">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_3.TITLE" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="w-100 d-flex custom-text">
                <p class="text_1">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_3.TEXT" | translate }}</p>
            </div>

        </mat-expansion-panel>
        <mat-expansion-panel class="pb-2">
            <mat-expansion-panel-header class="custom-expansion-panel" step-number="4">
                <mat-panel-title class="subtitle_1 custom-panel-title">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_4.TITLE" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="w-100 d-flex custom-text">
                <p class="text_1">{{ "PROCESSES.ACCOMMODATION.LIST.RENTAL_PROCEDURE.STEP_4.TEXT" | translate }}</p>
            </div>

        </mat-expansion-panel>


    </mat-accordion>
</div>


<app-accommodation-booking-documents></app-accommodation-booking-documents>

<app-accommodation-cancel-politic></app-accommodation-cancel-politic>

